import { useMemo, useState } from 'react';

import { useInputValue } from '../../../../hooks';
import useCreateNewAPIToken from '../../../shared/user/hooks/useCreateNewAPIToken';
import type { APITokenCreateRequest } from '../../../../../shared/settings/apiTokens';

export type APITokenStep = 'create' | 'existing';

/**
 * Hook for managing the state of the APITokenStep in the CLIUploadGuide.
 * Mostly this means handling the request as well as some of the simple state
 * like which step they are on, and the name input value.
 */
export default function useAPITokenStep() {
  const [apiTokenStep, setApiTokenStep] = useState<APITokenStep>('existing');
  const [tokenName, onTokenNameChange] = useInputValue();

  //  Memoizes so that the body is only recreated when the tokenName changes
  const body: APITokenCreateRequest = useMemo(() => ({ name: tokenName, pushOnly: 'true' }), [tokenName]);
  const { asyncValue, onCreateNewAPIToken } = useCreateNewAPIToken(body);
  const token = asyncValue.value?.token ?? null;

  return {
    apiTokenStep,
    hasAPIToken: apiTokenStep === 'existing',
    setApiTokenStep,
    tokenName,
    onTokenNameChange,
    isCreatingToken: asyncValue.isLoading,
    token,
    onCreateNewAPIToken,
    tokenOrFallbackText: token || '<YOUR_API_KEY>',
  };
}
